module.exports = __webpack_public_path__ + "img/view-jddetail.33a8068a.svg";